/**
 * Application footer component
 * 
 * @author Claude
 */
import { Box, Container, Typography, Link } from '@mui/material';

/**
 * Footer component with copyright and links
 * @returns {JSX.Element} Footer component
 * 
 * @a11y Uses semantic footer element
 * @a11y Links have descriptive text
 */
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[50],
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', sm: 'flex-start' },
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {currentYear} Accessibility Maturity Reporter
          </Typography>
          
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 1, sm: 3 },
              alignItems: 'center',
              mt: { xs: 2, sm: 0 },
            }}
          >
            <Link
              href="/privacy"
              color="text.secondary"
              variant="body2"
              underline="hover"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              color="text.secondary"
              variant="body2"
              underline="hover"
            >
              Terms of Service
            </Link>
            <Link
              href="/accessibility"
              color="text.secondary"
              variant="body2"
              underline="hover"
            >
              Accessibility Statement
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};